
















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { MCUpdateStatus } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { VImageUpload } from '@/components/upload'
import { TxLocal } from '@/utils/local/TxLocal'
import constant from '@/utils/constant'

@Component({
  components: {
    VTable,
    VImageUpload,
  },
})
export default class ChangeStatusMedicineCabineDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
  }
  private MedicineCabinetStatus = constant.MedicineCabinetStatus
  private data: any = {}
  private show = false
  
  public async open(data: any) {
    this.show = true
    this.data = data

  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    status: [this.requiredRule],
  }

  public async save() {


    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
      

        let result = {}

        result = await MCUpdateStatus({
          medicineCabinetId: this.data.id,
          medicineCabinetStatus: this.data.status
        })
       
        console.log(result)
        if(result){
          this.close()
        }
        
      } else {
        return false
      }
    })
  }
}
